import { createSlice } from '@reduxjs/toolkit';

import { COURSE_PAUSE_MODAL_STAGES } from '@courseResume/data/coursePauseModalStages';
import { CANCEL_PAUSE_REQUEST_MODAL_STAGES } from '@courseResume/data/cancelPauseRequestModalStages';
import { COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES } from '@courseResume/data/coursePauseRequestApproveModalStages';
import { COURSE_PAUSE_RESCHEDULE_MODAL_STAGES } from '@courseResume/data/coursePauseRescheduleModalStages';
import { EDIT_PAUSE_DURATION_MODAL_STAGES } from '@courseResume/data/editPauseDurationModalStages';
import { COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES } from '@courseResume/data/coursePauseRequestedRequestModalStages';

const initialState = {
  coursePauseModalStage: COURSE_PAUSE_MODAL_STAGES.notOpen,
  cancelPauseRequestModalStage: CANCEL_PAUSE_REQUEST_MODAL_STAGES.notOpen,
  editPauseDurationModalStage: EDIT_PAUSE_DURATION_MODAL_STAGES.notOpen,
  coursePauseRescheduleModalStage: COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.notOpen,
  coursePauseRequestApproveModalStage:
    COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.notOpen,
  coursePauseRequestedRequestUpdateModalStage:
    COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.notOpen,
  viewLectureModalState: false,
  selectedSuperBatch: null,
  selectedSbatLecture: null,
  selectedRequest: null,
  sortRequestField: null,
  sortRequestType: null,
  currentPage: 1,
  updateDurationType: null,
  updateDurationSource: null,
  updateDurationMonthsBy: null,
  coursePauseRequestedDuration: null,
  coursePauseRequestedStreakEnabled: false,
};

export const coursePauseRequest = createSlice({
  name: 'coursePauseRequest',
  initialState,
  reducers: {
    setCoursePauseManageModalStage: (state, action) => {
      state.coursePauseModalStage = action.payload;
    },
    setSelectedRequest: (state, action) => {
      state.selectedRequest = action.payload;
    },
    setSelectedSuperBatch: (state, action) => {
      state.selectedSuperBatch = action.payload;
    },
    setSelectedSbatLecture: (state, action) => {
      state.selectedSbatLecture = action.payload;
    },
    setSortRequestField: (state, action) => {
      state.sortRequestField = action.payload;
    },
    setSortRequestType: (state, action) => {
      state.sortRequestType = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setCancelRequestModalStage: (state, action) => {
      state.cancelPauseRequestModalStage = action.payload;
    },
    setEditDurationModalStage: (state, action) => {
      state.editPauseDurationModalStage = action.payload;
    },
    setViewLectureModalState: (state, action) => {
      state.viewLectureModalState = action.payload;
    },
    setUpdateDurationType: (state, action) => {
      state.updateDurationType = action.payload;
    },
    setUpdateDurationSource: (state, action) => {
      state.updateDurationSource = action.payload;
    },
    setUpdateDurationMonthsBy: (state, action) => {
      state.updateDurationMonthsBy = action.payload;
    },
    setCoursePauseRescheduleModalStage: (state, action) => {
      state.coursePauseRescheduleModalStage = action.payload;
    },
    setCoursePauseRequestApproveModalStage: (state, action) => {
      state.coursePauseRequestApproveModalStage = action.payload;
    },
    setCoursePauseRequestedRequestUpdateModalStage: (state, action) => {
      state.coursePauseRequestedRequestUpdateModalStage = action.payload;
    },
    setCoursePauseRequestedDuration: (state, action) => {
      state.coursePauseRequestedDuration = action.payload;
    },
    setCoursePauseRequestedStreakEnabled: (state, action) => {
      state.coursePauseRequestedStreakEnabled = action.payload;
    },
    resetUpdateDuration: (state) => {
      state.updateDurationType = null;
      state.updateDurationSource = null;
      state.updateDurationMonthsBy = null;
      state.selectedRequest = null;
    },
  },
});

export const {
  setCoursePauseManageModalStage,
  setCoursePauseRequestApproveModalStage,
  setCoursePauseRescheduleModalStage,
  setCancelRequestModalStage,
  setEditDurationModalStage,
  setViewLectureModalState,
  setSelectedRequest,
  setSelectedSuperBatch,
  setSelectedSbatLecture,
  setSortRequestField,
  setSortRequestType,
  setCurrentPage,
  setUpdateDurationType,
  setUpdateDurationSource,
  setUpdateDurationMonthsBy,
  setCoursePauseRequestedRequestUpdateModalStage,
  setCoursePauseRequestedDuration,
  setCoursePauseRequestedStreakEnabled,
  resetUpdateDuration,
} = coursePauseRequest.actions;
export default coursePauseRequest.reducer;
